import { cloneElement } from 'react';
import { bool, node } from 'prop-types';

import { CheckCircledIcon, Flex, Text } from '@cof/plastic-components';
import { css, keyframes, styled, useTheme } from 'styled-components';

const StyledFlex = styled(Flex)`
    ${({ theme }: any) => css`
        flex-direction: row;
        align-items: center;
        ${theme.components.StyledFlex};
    `}
`;

const fadeInKeyFrames = () => keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 100;
    }
`;

const translateText = (amount: any) => keyframes`
    from {
        transform: translateX(-${amount}px);
    }
    to {
        transform: translateX(0);
    }
`;

const FadeIn = styled.div`
    transform-origin: middle middle;
    padding-right: 0.6rem;
    animation: ${fadeInKeyFrames()} 0.2s ease;
    max-height: ${(props: any) => props.height};
`;

const Translate = styled.div`
    animation: ${(props: any) => translateText(props.$amount)} 0.2s ease;
`;

const CheckedLabel = ({ children, isSmall = false, isVisible = false }: any) => {
    const theme = useTheme();

    const iconConfig = {
        size: isSmall ? 16 : 20,
        color: isSmall ? 'inherit' : null
    };

    const coloured = cloneElement(
        // @ts-expect-error TS2322: Type '"inherit"' is not assignable to type 'ResponsiveValue<"regular" | "medium" | "semiBold", Defau
        <Text fontWeight="inherit" size="inherit" color={iconConfig.color} data-qm-allow>
            {children}
        </Text>,
        {
            ...(isVisible && {
                // @ts-expect-error TS2339: Property 'componentColors' does not exist on type 'DefaultTheme'.
                color: theme.componentColors.forms.input.border.success.toLowerCase()
            })
        }
    );
    return (
        <StyledFlex>
            {isVisible ? (
                <>
                    {/* @ts-expect-error TS2769: No overload matches this call. */}
                    <FadeIn height={isSmall ? '16px' : '20px'}>
                        <CheckCircledIcon size={iconConfig.size} color="capitalOne.green650" />
                    </FadeIn>
                    {/* @ts-expect-error TS2769: No overload matches this call. */}
                    <Translate $amount={iconConfig.size}>{coloured}</Translate>
                </>
            ) : (
                coloured
            )}
        </StyledFlex>
    );
};

CheckedLabel.propTypes = {
    children: node.isRequired,
    isVisible: bool,
    isSmall: bool
};

export default CheckedLabel;
